import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../actions/ts_overlay_actions.js';
import {updateModal} from '../../actions/modal.js';
import {Button, Modal, Grid,Row,Col,Clearfix, ButtonToolbar, DropdownButton, MenuItem, ButtonGroup,Dropdown} from 'react-bootstrap';
import {
  CirclePicker
} from 'react-color';
import Draggable from 'react-draggable';
//import HTML2Canvas from 'html2canvas';
import ReactDOM from 'react-dom';
import {getGameTitle, getMapTitle} from '../../utils/maps/titleUtil.js';
var Utility = React.createClass({


  changeColor(color) {
    var {dispatch,overlay} = this.props;
    dispatch(changeColor(color,overlay.color1,overlay.color2));
  },

  render() {
    var {overlay,map,currentUser,canvas} = this.props;
    var pencilIcon = 'fa fa-th fa-fw icon-white';
    var img =   <div><i className={pencilIcon}></i></div>

    return (
      <span>

  </span>

    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay, map: state.map, currentUser: state.currentUser, canvas:state.canvas
  }
})(Utility);



// WEBPACK FOOTER //
// ./src/app/components/tools/utility.js